import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const plusVariants = cva('', {
  variants: {
    variant: {
      'grey-header': css.greyHeader,
      'green-header': css.greenHeader,
    },
  },
});

interface PlusProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof plusVariants> {}

const Plus = forwardRef<HTMLDivElement, PlusProps>(
  ({ variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(plusVariants({ variant }), props.className)}
      >
        <span className={css.first}></span>
        <span className={css.second}></span>
      </div>
    );
  },
);

const Minus = forwardRef<HTMLDivElement, PlusProps>(
  ({ variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(plusVariants({ variant }), props.className)}
      >
        <span className={css.second}></span>
      </div>
    );
  },
);

export { Minus, Plus };
